export const RPMLimelightBlock = (function() {
	'use strict';

	const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

	function init() {
		const calendars = document.querySelectorAll('.rpmblock--limelight-calendar .rpm-calendar .calendar');
		if (!calendars.length) return;

		// The plugin renders on DOMContentLoaded; label now, and again if it (re)renders later
		calendars.forEach((calendar) => {
			addLabels(calendar);
			new MutationObserver(() => addLabels(calendar)).observe(calendar, { childList: true, subtree: true });
		});
	}

	/**
	 * Mobile list needs "TUE / MAR 9" per day; the plugin's boxes only show the day number.
	 * Monthly/two-month boxes carry data-performance-date (YYYY-MM-DD); weekly boxes run
	 * consecutively from today, so their date comes from their position.
	 */
	function addLabels(calendar) {
		colorLabeledTimes(calendar);

		const isWeekly = calendar.classList.contains('calendar--weekly');
		const today = new Date();
		today.setHours(12, 0, 0, 0);

		calendar.querySelectorAll('.calendar__grid').forEach((grid) => {
			grid.querySelectorAll('.day-box:not(.offset)').forEach((box, i) => {
				const inner = box.querySelector('.day-box-inner');
				if (!inner || inner.querySelector('.box-label')) return;

				// weekly doesn't flag non-playing days like monthly does (day-box-dark)
				box.classList.toggle('day-box--empty', !box.querySelector('.event-time'));

				let date;
				if (box.dataset.performanceDate) {
					const [y, m, d] = box.dataset.performanceDate.split('-').map(Number);
					date = new Date(y, m - 1, d, 12);
				} else if (isWeekly) {
					date = new Date(today);
					date.setDate(today.getDate() + i);
				} else {
					return;
				}

				const label = document.createElement('div');
				label.className = 'box-label';
				label.innerHTML = `<span class="box-weekday">${WEEKDAYS[date.getDay()]}</span><span class="box-monthday">${MONTHS[date.getMonth()]} ${date.getDate()}</span>`;
				inner.insertBefore(label, inner.firstChild);
			});
		});
	}

	/**
	 * Labeled showtimes (e.g. Best Availability) get the label's own color as a background.
	 * Works for any slug set in Limelight Settings (manual and ticket-based labels).
	 */
	function colorLabeledTimes(calendar) {
		const data = (window.limelight && window.limelight.data) || {};
		const labels = [].concat(data.labels || [], data.ticket_based_labels || []);
		if (!labels.length) return;

		const colors = {};
		labels.forEach((label) => {
			if (label.label_color) colors[labelSlug(label)] = label.label_color;
		});

		calendar.querySelectorAll('a.event-time:not(.event-time--labeled)').forEach((time) => {
			const slug = Object.keys(colors).find((s) => time.classList.contains('event-time--' + s));
			if (!slug) return;
			time.classList.add('event-time--labeled');
			time.style.setProperty('--label-color', colors[slug]);
		});
	}

	// same slug rules as the plugin (generateLabelSlug in limelight-calendar/public/app.js)
	function labelSlug(label) {
		const text = label.label_slug || label.label_title || '';
		return text.replace(/[^a-zA-Z0-9\s-]/g, '').toLowerCase().replace(/\s+/g, '-');
	}

	return {
		init: init
	};
})();
